import styled from "styled-components";
import { Nav, NavItem, FormGroup, Table, Form } from "react-bootstrap";

export const HeaderWrapper = styled.span`
    font-weight: 700;
    color: #333;
    line-height: 1.25;
    display: inline-block;
    padding: 0 4px;
`;

export const WatrListShell = styled.div`
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    padding: 20px 28px 28px;

    &.is-viewer-open {
        padding: 0;
        overflow: visible;
    }

    &.is-viewer-open .watr-document-viewer-slot {
        position: fixed;
        top: 62px;
        left: 12px;
        right: 12px;
        bottom: 12px;
        z-index: 1200;
        flex: none;
        width: auto;
        max-width: none;
        min-width: 0;
        min-height: 0;
        height: auto;
        overflow: hidden;
    }

    &.is-viewer-open .watr-document-viewer-slot .rc-drawer,
    &.is-viewer-open .watr-document-viewer-slot .rc-drawer-content-wrapper,
    &.is-viewer-open .watr-document-viewer-slot .rc-drawer-content {
        height: 100%;
        max-height: 100%;
        overflow: hidden;
    }

    &.is-viewer-open.is-request-open .watr-document-viewer-slot {
        right: calc(min(720px, 100vw) + 12px);
        margin-right: 0;
    }

    &.is-viewer-open .watr-list-main {
        display: none;
    }

    .watr-document-viewer-slot {
        position: relative;
        flex: 0 0 53vw;
        width: 53vw;
        max-width: 53vw;
        min-width: 0;
        min-height: 70vh;
    }

    .watr-list-main {
        flex: 1 1 auto;
        min-width: 0;
    }
`;

export const WatrPage = styled.div`
    padding: 0 10px;
    box-sizing: border-box;
`;

export const WatrPagePanel = styled.div`
    width: 100%;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    min-height: 70vh;
    padding: 20px 10px 10px;
    margin-bottom: 10px;
    background-color: #fff;
    box-sizing: border-box;
    cursor: default;
`;

export const GridWrapper = styled.div`
    height: ${p => p.height ? p.height : '68vh'};
    max-height: ${p => p.height ? p.height : '68vh'};
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    font-size: 15px;
    margin-top: 12px;
    cursor: default;

    .ag-root-wrapper,
    .ag-root {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        height: 100%;
        max-height: 100%;
        overflow: hidden;
    }

    .ag-body-horizontal-scroll,
    .ag-body-horizontal-scroll-viewport,
    .ag-body-horizontal-scroll-container {
        display: none !important;
        height: 0 !important;
        min-height: 0 !important;
        max-height: 0 !important;
        overflow: hidden !important;
    }

    .ag-body-viewport,
    .ag-center-cols-viewport {
        overflow-x: hidden !important;
    }

    .ag-center-cols-container {
        min-width: 0 !important;
    }

    .ag-root-wrapper,
    .ag-root,
    .ag-header,
    .ag-header-viewport,
    .ag-header-container,
    .ag-header-row,
    .ag-header-cell,
    .ag-header-cell-sortable,
    .ag-header-cell-label,
    .ag-header-group-cell,
    .ag-body-viewport,
    .ag-center-cols-clipper,
    .ag-center-cols-viewport,
    .ag-center-cols-container,
    .ag-full-width-container,
    .ag-overlay,
    .ag-cell,
    .ag-cell-wrapper,
    .ag-react-container,
    .ag-row {
        cursor: default !important;
    }

    a[href],
    button:not(:disabled),
    .btn:not(.disabled):not(:disabled),
    .dropdown-toggle:not(:disabled) {
        cursor: pointer !important;
    }

    @media (max-width: 1920px) {
        font-size: 15px;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 8px;
        padding-bottom: 8px;
        font-weight: 700;
        color: #333;
    }

    .ag-header-cell.watr-name-header-left {
        justify-content: flex-start;
    }

    .ag-header-cell.watr-name-header-left > .ag-react-container {
        justify-content: flex-start;
        width: 100%;
    }

    .ag-header-cell.watr-name-header-left > .ag-react-container > div {
        justify-content: flex-start;
        text-align: left;
        width: 100%;
    }

    .ag-header-cell.watr-donor-alias-header-left {
        justify-content: flex-start;
    }

    .ag-header-cell.watr-donor-alias-header-left > .ag-react-container {
        justify-content: flex-start;
        width: 100%;
    }

    .ag-header-cell.watr-donor-alias-header-left > .ag-react-container > div {
        justify-content: flex-start;
        text-align: left;
        width: 100%;
    }

    &.watr-der-verify-grid .ag-header-cell {
        align-items: center;
        padding-top: 0;
        padding-bottom: 0;
        overflow: visible;
    }

    &.watr-der-verify-grid .ag-header,
    &.watr-der-verify-grid .ag-header-viewport,
    &.watr-der-verify-grid .ag-header-container,
    &.watr-der-verify-grid .ag-header-row {
        background-color: lightgray;
        overflow: visible;
    }

    &.watr-der-verify-grid .ag-header-row {
        height: 100%;
    }

    &.watr-der-verify-grid .ag-header-cell > .ag-react-container {
        align-items: center;
        height: 100%;
        overflow: visible;
    }

    &.watr-der-verify-grid .ag-header-cell > .ag-react-container > div {
        align-items: center !important;
        height: 100%;
        justify-content: center;
    }

    &.watr-der-verify-grid .customHeaderLabel {
        line-height: 1.1;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: 700;
        color: #333;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: 700;
        color: #333;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .customHeaderLabel {
        font-weight: 700;
        color: #333;
    }

    .ag-cell {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .ag-cell.watr-status-pill-cell {
        overflow: hidden;
        min-width: 0;
    }

    .ag-cell.watr-status-pill-cell > .ag-react-container {
        min-width: 0;
        max-width: 100%;
        overflow: hidden;
    }

    .ag-cell.watr-name-cell-centered {
        justify-content: flex-start;
        text-align: left;
        overflow: hidden;
        min-width: 0;
    }

    .ag-cell.watr-name-cell-centered > .ag-react-container {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
    }

    .watr-name-cell-center-wrap {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow: hidden;
    }

    .watr-name-cell-text {
        text-align: left;
        font-weight: 700;
        font-size: 16px;
        color: #212529;
        box-sizing: border-box;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .ag-header-cell.watr-name-header-center {
        justify-content: center;
    }

    .ag-header-cell.watr-name-header-center > .ag-react-container {
        justify-content: center;
        width: 100%;
    }

    .ag-header-cell.watr-name-header-center > .ag-react-container > div {
        justify-content: center;
        text-align: center;
        width: 100%;
    }

    .ag-cell.watr-donor-alias-cell-left {
        justify-content: flex-start;
        text-align: left;
        padding-right: 16px;
    }

    .ag-cell.watr-donor-alias-cell-left > .ag-react-container {
        width: 100%;
        justify-content: flex-start;
    }

    .ag-header-cell.watr-center-header-left {
        justify-content: flex-start;
    }

    .ag-header-cell.watr-center-header-left > .ag-react-container {
        justify-content: flex-start;
        width: 100%;
    }

    .ag-header-cell.watr-center-header-left > .ag-react-container > div {
        justify-content: flex-start;
        text-align: left;
        width: 100%;
    }

    .ag-cell.watr-center-cell-left {
        justify-content: flex-start;
        text-align: left;
    }

    .ag-cell.watr-center-cell-left > .ag-react-container {
        width: 100%;
        justify-content: flex-start;
    }

    .donor-connect-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-connect-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-connect-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-connect-drop-down > .ag-react-container {
        width: 100%;
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        display: flex !important;
        align-items: center;
        justify-content: stretch !important;
        text-align: left;
        box-sizing: border-box;
    }

    .action-menu .ag-cell-wrapper,
    .action-menu .ag-cell-value,
    .action-menu .ag-react-container {
        width: 100% !important;
        max-width: 100%;
        min-width: 0;
        flex: 1 1 auto;
        display: block !important;
        box-sizing: border-box;
    }

    .ag-header-cell.action-menu-header > .ag-react-container {
        width: 100%;
        justify-content: center;
    }

    .action-menu .watr-action-cell {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 80px;
        align-items: center;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        column-gap: 6px;
    }

    .action-menu .watr-action-cell--solo {
        grid-template-columns: 1fr;
        justify-items: center;
    }

    .action-menu .watr-action-cell__primary {
        display: flex;
        justify-content: flex-start;
        min-width: 0;
        overflow: hidden;
    }

    .action-menu .watr-action-cell__primary .btn {
        min-width: 0;
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
    }

    .action-menu .watr-action-cell__menu {
        display: flex;
        justify-content: flex-end;
        width: 80px;
        overflow: visible;
    }

    .action-menu .watr-action-cell--solo .watr-action-cell__menu {
        width: auto;
        justify-content: center;
    }

    .action-menu .watr-action-cell__menu .btn {
        width: 80px;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        box-sizing: border-box;
    }

    .ag-row {
        z-index: 0;
        border-bottom: 1px solid #e0e0e0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-row:hover {
        background-color: #eaf2fa;
    }

    span.targeted > .dropdown {
        padding: 0px;
    }

    span.targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.active-targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: yellow;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.category > .dropdown > .dropdown-toggle {
        background-color: transparent;
        // color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    .dropdown > .dropdown-toggle {
        font-size: ${p => p.fontSize ? p.fontSize : '15px'};
    }

    // .dropdown-menu {
    //     font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    // }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }
`;



export const StyledTable = styled.div`
    margin-bottom: 0px;

    /* Styling for the .well container */
    // .well {
    //     padding: 30px;  /* 10px padding inside the well */
    //     background-color: #f7f7f7;
    //     overflow-x: auto;  /* Enable scrolling if the table is wider */
    //     width: 100%;
    //     max-width: 100%;
    // }

    /* Table container styling */
    .table-container {
        width: 100%;
        max-width: 100%;
    }

    /* Header Row Styling */
    .table-header {
        background-color: #b0b0b0; /* Darker Grey Header */
        color: black;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }

    .table-header > div {
        text-align: center;
        padding: 3px;  /* Padding inside header cells */
        border-right: 2px solid black; /* Black Vertical Lines */
        border-top: 2px solid black; /* Black Vertical Lines */
    }

 
    /* Remove the border-right from the last column in the header */
    .table-header > div:last-child {
        border-right: 2px solid black;
    }

      .table-header > div:first-child {
        border-right: 2px solid black;
        border-left: 2px solid black;
    }
    

    /* Table Body Styling */
    .table-row {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }

    /* Alternating Row Colors */
    .table-row:nth-child(even) {
        background-color: #f9f9f9; /* Light Grey */
    }

    .table-row:nth-child(odd) {
        background-color: white; /* White */
    }

    /* Row cell styling */
    .table-row > div {
        text-align: center;
        padding: 2px; /* Padding inside cells */
        border-right: 2px solid black; /* Black Vertical Lines */
    }

    /* Remove the border-right from the last column in the row */
    .table-row > div:last-child {
        border-right: 2px solid black;
         
    }

     .table-row > div:first-child {
        border-left: 2px solid black;
    }

    .table-footer {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        width: 100%;
        border-top: 2px solid black;
    }

    .no-wrap {
        white-space: nowrap;
    }

    /* Responsive Font Adjustments */
    @media (max-width: 1823px) {
        .table-header > div,
        .table-row > div {
            font-size: 12px;  /* Smaller font size for smaller screens */
        }
    }
`;


export const ReImburseTableWrapper = styled(Table)`
    width: initial;
    border-collapse: collapse; /* Ensures proper border rendering without gaps */
    border: 1px solid black; /* Outer border around the table */

    margin-bottom: 5px;

    /* Header Styling */
    & > thead {
        background-color: #ddd;
    }

    & > thead > tr > th {
        border: 1px solid black; /* Borders around each header cell */
        text-align: center;
        padding: 4px; /* Reduced padding */
        vertical-align: middle;
    }

    /* Body Styling */
    & > tbody > tr {
        border: 1px solid black; /* Ensures no gaps between rows */
    }

    & > tbody > tr > td {
        border: 1px solid grey; /* Consistent column borders */
        text-align: center;
        padding: 4px; /* Reduced padding */
        vertical-align: middle;
    }

    /* Alternating Row Colors */
    & > tbody > tr:nth-child(even) {
        background-color: #f9f9f9; /* Light Grey */
    }

    & > tbody > tr:nth-child(odd) {
        background-color: white; /* White */
    }

    /* Footer Styling */
    & > tfoot > tr {
        border: 1px solid black; /* Top border for footer */
        background-color: #ddd; /* Footer background */
        font-weight: bold;
    }

    & > tfoot > tr > td {
        border: 1px solid black; /* Consistent footer cell borders */
        text-align: center;
        padding: 4px;
        vertical-align: middle;
    }
`;

export const StyledContainer = styled.div`
    margin-bottom: 0px;

    .header-row {
        text-align: center;
        font-weight: bold;
        padding: 10px 0;
        border-bottom: 1px solid white;
    }

    .header-row > div {
        border-right: 1px solid white;
    }

    .header-row > div:last-child {
        border-right: none;
    }

    .data-row {
        text-align: center;
        vertical-align: middle;
        padding: 8px 0;
    }

    @media (max-width: 1823px) {
        .header-row > div,
        .data-row > div {
            font-size: 12px;
        }

        .data-row .badge {
            font-size: 12px;
        }

        .data-row .btn {
            font-size: 12px;
        }
    }
`;

export const TableWrapper = styled.div`
    .table {
        border: 1px solid #eee;
        border-radius: 4px;
    }

    .table > thead > tr {
        background-color: #222628;
        color: #fff;
    }

    .table > thead > tr > th {
        text-align: center;
        border: 1px solid #fff;   
    }

    .table > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    .table > tbody {
        // border: 1px solid pink;
        height: 400px;
    }

     .table-striped>tbody>tr:nth-of-type(even) {
         background-color: darkgrey !important;
         color: #fff;
     }

     .table-striped>tbody>tr:nth-of-type(odd) {
         background-color: #181d1f !important;
         color: #fff;
     }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    tabHeight?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    // & > li {
    //     height: 52px;
    // }

    & > .acc-tabs > li {
        /* height: 48px; */
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .acc-pills > li > a {
        padding: 5px 7px;
        // font-size: ${(p: INavWrapperProps) => p.fontSize != null ? p.fontSize : '14px'};
    }

    & > div > .acc-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 7px;
        color: #ccc;
    }

    & > div > .acc-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

export const ViewWrapper = styled.div`
    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    display: flex;
    align-items: center;

    & > .col-lg-3 {
        padding-left: 0px;
    }
`;

interface INavItemProps {
    tabWidth?: string,
    minTabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    // }
`;

export const ReimbursementTableWrapper = styled(Table)`
    & > thead > tr > th {
        background-color: #eee;
    }
    
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

export const WatrNavWrapper = styled(Nav) <INavWrapperProps>`
    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 15px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        text-align: center;
        padding: 8px 16px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'center'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & .watr-nav-shell {
        box-sizing: border-box;
        width: 100%;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 8px 12px;
    }

    & .watr-nav-shell--open-bottom {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom-color: transparent;
        padding-bottom: 4px;
    }

    & .watr-nav-shell--continuation {
        border-top: none;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        padding-top: 4px;
    }

    & .watr-nav-shell-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        min-width: 0;
    }

    & .watr-nav-shell-header > .ms-parent-pills {
        flex: 1 1 auto;
        min-width: 0;
    }

    & .watr-nav-shell-actions {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
    }

    & .watr-nav-shell--with-children > .watr-nav-shell-header {
        padding-bottom: 8px;
        margin-bottom: 8px;
        border-bottom: 1px solid #ddd;
    }

    & .ms-parent-pills,
    & .ms-child-tabs,
    & .ms-pills {
        display: flex !important;
        flex-wrap: wrap;
        align-items: center;
        margin: 0;
        padding: 0;
    }

    & .ms-parent-pills > li,
    & .ms-child-tabs > li,
    & .ms-pills > li {
        float: none !important;
    }

    & .ms-parent-pills > li > a {
        font-size: 15px;
        font-weight: 600;
        line-height: 1.25;
        padding: 8px 14px;
    }

    & .ms-child-tabs > li > a,
    & .ms-pills:not(.ms-parent-pills) > li > a {
        font-size: 14px;
        font-weight: 600;
        line-height: 1.25;
        padding: 6px 12px;
    }

    & .ms-pills > li > span {
        position: relative;
        display: block;
        font-size: 14px;
        padding: 8px 6px;
        color: #ccc;
    }

    & .ms-pills > li.li-divider {
        height: 34px;
        display: flex;
        align-items: center;
        float: none !important;
        list-style: none;
    }

    & .ms-parent-pills > li.li-divider {
        height: 38px;
    }

    & .ms-pills > li > div.pill-divider {
        margin-left: 6px;
        margin-right: 6px;
        height: 14px;
        width: 1px;
        min-width: 1px;
        background-color: #ccc;
        flex-shrink: 0;
    }

    & .ms-parent-pills > li > a:hover,
    & .ms-child-tabs > li > a:hover,
    & .ms-pills > li > a:hover {
        background-color: #a0c5e5 !important;
        color: #000 !important;
    }

    & .ms-parent-pills > li.active > a:hover,
    & .ms-child-tabs > li.active > a:hover,
    & .ms-pills > li.active > a:hover {
        background-color: #3B76B5 !important;
        color: #fff !important;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }
`;

export const WatrNavItemWrapper = styled(NavItem) <INavItemProps>`
    min-height: 34px;
    height: auto;
    display: flex !important;
    align-items: center;
    text-align: center;

    & > a {
        display: flex !important;
        align-items: center;
        justify-content: center;
    }

    & > a > span.badge {
        font-size: 12px;
    }

    & > a > span.type-count {
        font-size: 13px;
    }
`;

export const VerifyWrapper = styled.div`
    .selected-btn {
        border: 1px solid #3b82f6;
        background: #eff6ff;
        color: #1d4ed8;
    }

    @media (width < 1920px) {
        font-size: 12px;

        .form-control {
            font-size: 12px;
        }
    }
`;

export const ReimbursementAddEditFormWrapper = styled(Form)`
    &.form-horizontal .form-group {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 8px;
    }

    &.form-horizontal .form-group > .control-label {
        float: none;
        flex: 0 0 168px;
        width: 168px;
        max-width: 168px;
        padding-top: 7px;
        padding-left: 0;
        padding-right: 12px;
        text-align: left;
    }

    &.form-horizontal .form-group > [class*='col-']:not(.control-label) {
        float: none;
        flex: 1 1 auto;
        width: auto;
        min-width: 0;
        padding-left: 0;
        padding-right: 0;
    }

    &.form-horizontal .form-control {
        max-width: 260px;
    }

    .wage-formula {
        padding-top: 7px;
        font-size: 13px;
        color: #5a6268;
        line-height: 1.4;
        font-variant-numeric: tabular-nums;
    }

    .wage-formula-line {
        display: flex;
        align-items: baseline;
        gap: 8px;
        white-space: nowrap;
    }

    .wage-formula-line + .wage-formula-line {
        margin-top: 2px;
    }

    .wage-formula-amt {
        min-width: 6.5em;
        text-align: left;
        color: #333;
        font-variant-numeric: tabular-nums;
    }

    .wage-formula-desc {
        color: #6b7280;
    }

    .wage-formula-note {
        display: block;
        margin-top: 4px;
        font-size: 12px;
        color: #6b7280;
    }
`;

export const ReimbursementWageNotes = styled.div`
    background: #f7f8fa;
    border: 1px solid #e3e6ea;
    border-radius: 4px;
    padding: 12px 14px;
    font-size: 14px;
    color: #5a6268;
    line-height: 1.45;

    .wage-note + .wage-note {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #e3e6ea;
    }

    .wage-note-title {
        display: block;
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
    }

    .wage-note-amount {
        display: block;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 6px;
    }

    .wage-note-meta {
        display: block;
        font-size: 13px;
        color: #5a6268;
        line-height: 1.4;
    }

    .wage-note-meta + .wage-note-meta {
        margin-top: 2px;
    }

    .wage-note-formula {
        display: block;
        margin-top: 8px;
        padding-top: 6px;
        border-top: 1px solid #e3e6ea;
        font-size: 13px;
        color: #333;
        line-height: 1.4;
        font-variant-numeric: tabular-nums;
    }

    .wage-note-formula-eq,
    .wage-note-formula-line {
        display: block;
        white-space: nowrap;
    }

    .wage-note-formula-line + .wage-note-formula-line {
        margin-top: 2px;
    }

    .wage-note-formula + .wage-note-meta {
        margin-top: 8px;
    }

    .wage-note p {
        margin: 0 0 8px;
    }

    .wage-note p:last-child {
        margin-bottom: 0;
    }

    .alert {
        margin-bottom: 0;
    }
`;

export const WatrDrawer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const WatrDrawerHead = styled.div`
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background: #ddd;

    h3 {
        margin: 0;
        font-size: 16px;
        line-height: 1.2;
    }
`;

export const WatrDrawerHeadActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const WatrDrawerDecision = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
`;

export const WatrDrawerFacts = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 1px;
    min-width: 0;
`;

export const WatrDrawerAmount = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: #212529;
    letter-spacing: -0.01em;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
`;

export const WatrDrawerDate = styled.span`
    font-size: 12px;
    color: #6c757d;
    line-height: 1.2;
`;

export const WatrDrawerActions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const WatrDrawerApproveBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 6px 14px;
    border: none;
    border-radius: 6px;
    background: #22863a;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    cursor: pointer;

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
        background: #1b7a34;
        color: #fff;
        outline: none;
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const WatrDrawerGhostBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 6px 10px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #495057;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    cursor: pointer;

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
        background: #f1f3f5;
        color: #212529;
        outline: none;
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const WatrDrawerTools = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    padding-left: 10px;
    margin-left: 4px;
    border-left: 1px solid #e9ecef;
`;

export const WatrDrawerIconBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #6c757d;
    cursor: pointer;

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
        background: #f1f3f5;
        color: #212529;
        outline: none;
    }

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const WatrDrawerPolicyLink = styled.a`
    color: blue;
    text-decoration: underline;
    white-space: nowrap;
    font-size: 12px;
    margin-right: 0;
`;

export const WatrDrawerBody = styled.div<{ $center?: boolean }>`
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 8px 10px 10px;

    ${p => p.$center ? `
        &::before,
        &::after {
            content: '';
            flex: 1 1 0;
            min-height: 0;
        }

        & > * {
            flex: 0 0 auto;
            width: 100%;
        }
    ` : ''}
`;

export const WatrDrawerFoot = styled.div`
    flex: 0 0 auto;

    .btn {
        padding: 6px 8px;
    }
`;